<script>
import { mapState, mapActions } from "vuex";

export default {
	data() {
		return {
			mode: "INSERT",
			myData: {},
			show: true,
			showImages: false,
			message: "",
			myOptions: {
				status: [
					{ text: "-", value: null },
					{ text: "Aktif", value: 1 },
					{ text: "Non Aktif", value: 0 },
				],
				kabupaten: [],
			},
			params: {},
			headers: {},
			imgDataUrl: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			auth: (state) => state.auth.user,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	components: {},
	created() {
      this.myData = {
         id: parseInt(this.$route.params.id),
      }
	},
	methods: {
		...mapActions({
			changePassword: "pengguna/changePassword",
		}),
		onSubmit() {
         this.changePassword(this.myData).then(() => {
            this.$router.push("/pengguna");
         });
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="Pengguna" title="Form Pengguna" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<form
								@submit.prevent="onSubmit"
								v-if="show"
								id="form-data"
							>
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label>Password Baru</label>
												<input
													v-model="myData.password"
													name="password"
													class="form-control"
													type="text"
													required
												/>
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="form-group"
												v-show="myData.group_id == 3"
											>
												<label
													>Lingkungan/Stasi
													<span class="text-danger">*</span></label
												>
												<vue-typeahead-bootstrap
													name="lingkungan_stasi"
													data-vv-as="Lingkungan/Stasi"
													v-model="myData.lingkungan_stasi"
													:minMatchingChars="1"
													:data="lingkunganStasi"
													size="sm"
												/>
											</div>
										</div>
									</div>
									<hr />
									<div class="row">
										<div class="col">
											<div class="form-group mb-0">
												<b-button
													class="mr-3"
													type="submit"
													variant="primary"
													:disabled="isLoading"
													form="form-data"
												>
													<span
														v-show="isLoading"
														class="
															spinner-border spinner-border-sm
														"
													></span
													><i
														class="fa fa-fw fa-save"
														v-show="!isLoading"
													></i>
													Simpan
												</b-button>
												<a
													class="btn btn-danger"
													href="#"
													@click="$router.push('/pengguna')"
													>Cancel</a
												>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</px-card>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
	</div>
</template>

